<template>
    <div class="bt-container clearfix">
        <div class="bt-content clearfix">
            <wp-step1 ref="WpStep1" v-if="step == 1"></wp-step1>
            <wp-step2 ref="WpStep2" v-if="step == 2"></wp-step2>
            <div class="overlay-loader" v-if="isLoading">
                <i class="overlay-img-load"></i>
            </div>
        </div>
    </div>
</template>

<script>

import {mapState, mapActions} from "vuex";
import WpStep1 from "./steps/WpStep1";
import WpStep2 from "./steps/WpStep2";

export default {
    name: 'WpCart',
    components: {WpStep1, WpStep2},
    props: {'resortSlug': null, 'page': null},

    mounted() {
        this.updateStep({'step': this.page});
        this.$store.state.step = this.page;
        this.currentLanguage();
    },

    computed: {
        ...mapState(['isLoading','step', 'resorts']),
    },

    watch: {
        resorts: function(newResorts, oldResorts){
            let _this = this;
            let slug = _this.resortSlug;
            var currentUrl = new URL(window.location.href);
            var urlParams = new URLSearchParams(currentUrl.search);
                if (urlParams.has('location')) {
                        console.log(urlParams.get('location'))
                        slug = urlParams.get('location');
                  }
            if(slug && newResorts && newResorts.length > 0){
                let currentResort = newResorts.find(res => res.slug === slug);
                if(currentResort && !urlParams.has('portal_name')){
                    _this.$store.dispatch('setResortID', {'resort_id' : currentResort.id});
                }

            }
        }
    },

    created() {
        this.currentLanguage();
        this.$store.dispatch('setDataFromStorage');
    },
    beforeCreate(){
        var link = document.createElement('link');
        link.setAttribute("rel",'stylesheet');
        link.setAttribute("href","https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
        document.head.appendChild(link);
    },
    methods:{
        ...mapActions(['setLoading', 'updateStep']),
        currentLanguage() {
            const lang = window.location.pathname.split('/')[1];
            console.log(window.location.pathname,window.location.pathname.split('/')[1],'developer test lang');
            if (['fr', 'en'].includes(lang)) {
                this.$i18n.locale = lang;
                localStorage.setItem('selectedLocale', this.$i18n.locale)
            }else{
                this.$i18n.locale = 'en';
                localStorage.setItem('selectedLocale', this.$i18n.locale)
            }
        }
    }
}
</script>


